/*****************************************************************************
 * UmanIT - Calculates price on product page
 *****************************************************************************/

const priceField = document.querySelector("[data-type='price-container']");
const pricePerKgField = document.querySelector("[data-type='priceperkg-container']");
const priceBaseField = document.querySelector("[data-type='base-price-container']");
const variants = Array.from(document.querySelectorAll("[data-type='main-product-variant'] input"));
const quantityContainer = document.querySelector("#sylius_add_to_cart_cartItem_quantity");
const buttons = document.querySelectorAll("[data-trigger='counter-btn']");
const buttonCart = document.querySelector("[data-role='product-cart-btn']");
const stock = document.querySelector("[data-role='main-out-of-stock']");
const isWebChannel = document.querySelector("[data-channel='FR_WEB']");
const staffDiscount = document.querySelector("[data-role='main-staff-discount']");

let price;
let pricePerKg;
let stringPrice;
let priceBase;
let quantity = quantityContainer.value;


promisePrice();
variants.forEach(function (variant) {
  variant.addEventListener("change", function () {
    promisePrice();
  });
});

quantityContainer.addEventListener("input", function () {
  promisePrice();
});

buttons.forEach(function (button) {
  button.addEventListener("click", function () {
    promisePrice();
  });
});

/**
 * Promesse
 *
 * 1. Récupération prix et prix au kilo de la variante sélectionnée
 * 2. Récupération de la quantité
 *    Calcul du prix total et transformation en chaîne de caractère
 *    Affichage du prix au kilo dans le conteneur dédié
 * 3. Affichage dy prix total dans le conteneur dédié
 */
function promisePrice() {
  const promise = new Promise(function (resolve) {
    let inputChecked = document.querySelector("[data-type='main-product-variant'] input:checked");
    let variant = inputChecked.closest("[data-type='main-product-variant']");

    resolve(variant);
  });

  promise
    .then(function (variant) {
      const itemsCount = getQuantity();

      if (variant.dataset.productprice) {
        const dataPrice = variant.dataset.productprice;
        const priceLength = dataPrice.length - 2;
        price = (dataPrice.slice(0, priceLength)).replace(",", ".");
        const numericPrice = parseFloat(price);
        const total = numericPrice * itemsCount;
        const totalLimitedDecimal = total.toFixed(2);

        stringPrice = (totalLimitedDecimal.toString()).replace(".", ",");
      }

      // Prix au kilo du produit sélectionné
      if (variant.dataset.priceperkg) {
        pricePerKg = variant.dataset.priceperkg;
        pricePerKgField.innerHTML = `(${pricePerKg} € / kg)`;
      } else {
        pricePerKgField.innerHTML = "(Prix au kg non renseigné)";
      }

      // Prix de base
      if (variant.dataset.productpricebase) {
        priceBase = variant.dataset.productpricebase;
        priceBaseField.innerHTML = `${priceBase}`;
        priceField.classList.add("product__price--promo");
        priceBaseField.classList.add("d-inline-flex");
      } else {
        priceBase = false;
        priceBaseField.classList.remove("d-inline-flex");
        priceField.classList.remove("product__price--promo");
      }

      if (variant.dataset.staffdiscount && staffDiscount) {
        staffDiscount.classList.add("d-block");
        staffDiscount.classList.remove("d-none");
      } else if(staffDiscount) {
        staffDiscount.classList.add("d-none");
        staffDiscount.classList.remove("d-block");
      }

      // Modification temporaire pour interdire la commande de produits en canal web
      if (isWebChannel) {
        buttonCart.setAttribute("disabled", "true");
        stock.classList.add("d-block");
        stock.classList.remove("d-none");
      } else if (variant.dataset.stock) {
        if (variant.dataset.stock == 0) {
          buttonCart.setAttribute("disabled", "true");
          stock.classList.add("d-block");
          stock.classList.remove("d-none");
        }
        //si on a ajouté plus d'items que le stock du produit
        else if (itemsCount > parseInt(variant.dataset.stock)) {
          buttonCart.setAttribute("disabled", "true");
          stock.classList.add("d-block");
          stock.classList.remove("d-none");
        }
        // sinon on affiche à nouveau les boutons
        else {
          buttonCart.removeAttribute("disabled");
          stock.classList.remove("d-block");
          stock.classList.add("d-none");
        }
      }
      // sinon on affiche à nouveau les boutons
      else {
        buttonCart.removeAttribute("disabled");
        stock.classList.remove("d-block");
        stock.classList.add("d-none");
      }

      return (stringPrice);

    })
    .then(function (stringPrice) {
      if (stringPrice) {
        priceField.innerHTML = `${stringPrice} €`;
      } else {
        priceField.innerHTML = "Prix non renseigné";
      }
    });
}

/**
 * Récupère le prix du produit
 *
 * @returns string {quantity}
 */
function parseData() {
  let inputChecked = document.querySelector("[data-type='main-product-variant'] input:checked");
  let variant = inputChecked.closest("[data-type='main-product-variant']");

  return variant;
}

/**
 * Récupère la quantité demandé pour le produit
 *
 * @returns int {quantity}
 */
function getQuantity() {
  quantity = quantityContainer.value;

  return quantity;
}
